import {Injectable, ViewChild} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {Event, Topic, Day, Activity} from '../models/event';
import {Observable} from 'rxjs';
import {FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {AngularFireStorageReference, AngularFireUploadTask, AngularFireStorage} from '@angular/fire/compat/storage';
import {finalize } from 'rxjs/operators';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import {Guid} from 'guid-typescript';
import {FileMaterial} from '../models/file-material';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';


@Injectable({
  providedIn: 'root'
})
export class TopicService {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  public currentEvent: Event;
  public currentDay: Day;
  public currentActivity: Activity;
  public currentTopic: Topic;

  public isEdit: boolean = false;
  public localTitle: string;
  public spinner: boolean = false;

  private itemDoc: AngularFirestoreDocument<Topic>;
  private item: Observable<Topic>;

  public objectImage: any = null;
  public storedImage: any;

  public topicDataSource: MatTableDataSource<any>;

  public pdfDataSource: MatTableDataSource<any>
  public selectedFile: any = "Nenhum arquivo selecionado.";
  public objectPdf: any = "none";

  public objectBannerTopic: any;
  public storedBannerTopic: any;

  constructor (
    private fs: AngularFireStorage,
    private db: AngularFirestore,
    private fb: FormBuilder,
    private snackBar: SnackBarIconService,
    private dialog: MatDialog,
  ) { }

  setEdit (): any {
    if (this.currentTopic && this.currentTopic.id) {
      this.isEdit = true
      this.localTitle = this.currentTopic.name
    } else {
      this.isEdit = false;
      this.localTitle = "Novo Tópico"
    }
  }

  createForm (topic) {

    let anyDate: any = this.currentActivity.date

    if (anyDate.seconds) {
      anyDate = new Date(anyDate.seconds * 1000)
      //console.log("any date edit true: " + anyDate)
    } else {
      anyDate = this.currentActivity.date
      // console.log("any date edit false: " + anyDate)
    }


    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      event_id: new FormControl(this.currentEvent.id, [ Validators.required ]),
      day_id: new FormControl(this.currentDay.id, [ Validators.required ]),
      activity_id: new FormControl(this.currentActivity.id, [ Validators.required ]),
      date: new FormControl(anyDate, [ Validators.required ]),
      name: new FormControl('', [ Validators.required ]),
      text: new FormControl(''),
      startTime: new FormControl('', [ Validators.required ]),
      duration: new FormControl('', [ Validators.required ]),
      //  team: new FormControl(''),
      speakers: new FormControl(''),
      material: new FormControl(''),

      sponsor_id: new FormControl(''),
      sponsor_name: new FormControl(''),
      banner: new FormControl(''),
      text1: new FormControl(''),
      text2: new FormControl(''),
      text3: new FormControl(''),

    });

    if (topic) {
      form.controls.id.setValue(topic.id);
      form.controls.name.setValue(topic.name);
      form.controls.text.setValue(topic.text);
      form.controls.startTime.setValue(topic.startTime);
      form.controls.duration.setValue(topic.duration);
      //  form.controls.team.setValue(topic.team);
      form.controls.speakers.setValue(topic.speakers);
      form.controls.material.setValue(topic.material);

      form.controls.sponsor_id.setValue(topic.sponsor_id);
      form.controls.sponsor_name.setValue(topic.sponsor_name);
      form.controls.banner.setValue(topic.banner);

      this.storedBannerTopic = topic.banner ? topic.banner : ""

      form.controls.text1.setValue(topic.text1 || '');
      form.controls.text2.setValue(topic.text2 || '');
      form.controls.text3.setValue(topic.text3 || '');

    }

    return form
  }

  select (activity_id) {
    let array: Topic[] = [];
    return this.db.collection<Topic>('sbccv_event_topics', ref => ref
      .where('activity_id', '==', activity_id)
      .where('deleted', '==', false)).snapshotChanges()
      .subscribe((result) => {
        array = result.map(item => {
          let topic = new Topic();
          topic.id = item.payload.doc.id;
          topic.event_id = item.payload.doc.data().event_id;
          topic.day_id = item.payload.doc.data().day_id;
          topic.activity_id = item.payload.doc.data().activity_id;
          topic.name = item.payload.doc.data().name;
          topic.date = item.payload.doc.data().date;
          topic.text = item.payload.doc.data().text;
          topic.startTime = item.payload.doc.data().startTime;
          topic.duration = item.payload.doc.data().duration;
          //   topic.team = item.payload.doc.data().team;
          topic.materials = item.payload.doc.data().materials;

          topic.sponsor_name = item.payload.doc.data().sponsor_name;
          topic.sponsor_id = item.payload.doc.data().sponsor_id;
          topic.banner = item.payload.doc.data().banner;

          topic.text1 = item.payload.doc.data().text1 || '';
          topic.text2 = item.payload.doc.data().text2 || '';
          topic.text3 = item.payload.doc.data().text3 || '';

          return topic;
        });

        array.sort(this.compareTopics)

        this.topicDataSource = new MatTableDataSource(array);
        this.topicDataSource.paginator = this.paginator;
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })
  }

  compareTopics (a, b) {

    const pa = String(a.startTime)
    const pb = String(b.startTime)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  selectById (topic_id) {
    this.itemDoc = this.db.doc<Topic>('sbccv_event_topics/' + topic_id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  selectByEventId (event_id) {
    return this.db.collection<Topic>('sbccv_event_topics', ref => ref
      .where('event_id', '==', event_id)
      .where('deleted', '==', false)).snapshotChanges()
  }

  async selectByEvents (events: string[]): Promise<any[]> {
    // console.log("getProductsByEvents: " + JSON.stringify(events))
    const array: any[] = [];

    for (const event_id of events) {
      try {
        const querySnapshot = await this.db.collection<Topic>('sbccv_event_topics', ref => ref
          .where('event_id', '==', event_id)
          .where('deleted', '==', false))
          .get()
          .toPromise();

        querySnapshot.forEach(doc => {
          // console.log("doc.id: " + doc.id)
          const data: any = {
            "id": doc.id,
            ...doc.data()
          }
          array.push(data);
        });

      } catch (error) {
        console.error(`Erro ao buscar agenda para o evento ${ event_id }:`, error);
      }
    }
    return array;
  }



  insert (topic: Topic) {
    this.spinner = true;
    const entity = this.createTopic(topic)

    return this.db.collection('sbccv_event_topics').add(Object.assign({}, entity))
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
        this.isEdit = true;
        return e.id
      })
      .catch((error) => {
        console.log("erro insert topic: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');

      })
      .finally(() => {
        this.spinner = false;
      })

  }

  update (id: string, topic: Topic) {

    this.spinner = true;
    const entity = this.createTopic(topic)

    return this.db.collection('sbccv_event_topics').doc(id).set(Object.assign({}, entity, {merge: true}))
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');

      })
      .catch((error) => {
        console.log("erro update topic: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  delete (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir este tópico?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        return this.db.collection('sbccv_event_topics').doc(element.id).set({deleted: true}, {merge: true})
      }
      else {
        return result
      }

    })
  }

  createTopic (data: any): Topic {
    let entity = new Topic()
    entity.name = data.name;
    //  entity.team = data.team;
    entity.text = data.text || '';
    entity.date = data.date;
    entity.startTime = data.startTime;
    entity.duration = data.duration;
    entity.event_id = this.currentEvent.id;
    entity.day_id = this.currentDay.id;
    entity.activity_id = this.currentActivity.id;

    entity.sponsor_id = data.sponsor_id ? data.sponsor_id : ""
    entity.sponsor_name = data.sponsor_name ? data.sponsor_name : ""
    entity.banner = data.banner ? data.banner : ""

    entity.text1 = data.text1 || '';
    entity.text2 = data.text2 || '';
    entity.text3 = data.text3 || '';

    if (!this.isEdit) {
      entity.deleted = false;
    }

    return entity;
  }


  makeMsgError (errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

  breadCrumb (value) {
    if (value) {
      if (value.length > 20) {
        return value.substr(0, 20) + " ..."
      } else {
        return value
      }
    } else {
      return "Novo"
    }

  }

  setPdfDataSource () {
    if (this.currentTopic)
      this.pdfDataSource = new MatTableDataSource(this.currentTopic.materials)
  }

  uploadMaterial (file, label) {

    const name = file.name;
    const lastDot = name.lastIndexOf('.');
    //   const fileName = file.name.substring(0, lastDot);
    const ext = name.substring(lastDot + 1);
    const key = Guid.create() + "." + ext;

    /*
    console.log("name  > " + name)
    console.log("label > " + label.name)
    console.log("ext   > " + ext)
    console.log("key   > " + key)
    */

    const fsRef: AngularFireStorageReference = this.fs.ref("events/materials/" + key);
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          console.log("uploaded.")
          this.updateFilePdfUrl(key, file, url, label)
        });
      }))
      .subscribe();

  }

  updateFilePdfUrl (key: any, file: any, url: any, data: any) {
    if (!this.currentTopic.materials) {
      this.currentTopic.materials = []
    } else {
      this.currentTopic.materials = this.currentTopic.materials.filter((e) => {
        return e.id != key
      })
    }

    const material = new FileMaterial()
    material.id = key
    material.name = data.name
    material.original = file.name
    material.storage = url

    this.currentTopic.materials.push(material)

    return this.db.collection('sbccv_event_topics').doc(this.currentTopic.id)
      .set(JSON.parse(JSON.stringify({materials: this.currentTopic.materials})), {merge: true})
      .then(() => {
        this.setPdfDataSource()
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("topic update pdf  error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })


  }

  removeMaterial (topic_id: any, material_id: any) {

    return this.db.collection('sbccv_event_topics').doc(topic_id)
      .get()
      .subscribe((result: any) => {

        let topic = result.data()

        let material = topic.materials.find((e) => {
          return e.id == material_id
        })

        if (material) {
          // remove from storage
          console.log("material.storage " + JSON.stringify(material.storage))

          return this.fs.storage.refFromURL(material.storage).delete()
            .then((e) => {
              console.log("remove material success")
              topic.materials = topic.materials.filter((e) => {
                return e.id != material_id
              })

              console.log("new_materials: " + JSON.stringify(topic.materials))

              this.db.collection('sbccv_event_topics').doc(topic_id).set({materials: topic.materials}, {merge: true})
                .then((e) => {

                  this.pdfDataSource = new MatTableDataSource(topic.materials)
                  this.snackBar.openSnackBar("Sucesso!", '', 'success');

                })
                .catch((error) => {
                  console.log("erro update topic: " + error)
                  this.snackBar.openSnackBar("Erro!", '', 'error');
                })
                .finally(() => {
                  this.spinner = false;
                })

            })
            .catch((error) => {
              console.log("error remove material " + error)
            })

        } else {
          console.log("material não encontrado.")
        }
      })
  }

  createPdfForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      original: new FormControl('', [ Validators.required ]),
      storage: new FormControl(''),
      url: new FormControl(''),
    });

    return form
  }


  previewBannerTopic (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectBannerTopic = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedBannerTopic = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadBannerTopic (data: any) {

    const fsRef: AngularFireStorageReference = this.fs.ref("images/topic/banners" + data.topic_id + "_banner.png");
    const fsTask: AngularFireUploadTask = fsRef.put(data.file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateBannerImage(data, url)
        });
      }))
      .subscribe();
  }

  updateBannerImage (data: any, url: any) {

    return this.db.collection('sbccv_event_topics').doc(data.topic_id).set(
      {
        'sponsor_id': data.sponsor_id,
        'sponsor_name': data.sponsor_name,
        'banner': url
      }
      , {merge: true})
      .then(() => {
        this.objectBannerTopic = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }


}
